import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: IrrigationTypeCreateInput!
  ) {
    createOneIrrigationType(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Tipo de rega criado`, mutationTypes.CREATE)
)
